import {
	type Block,
	type TextAttributes,
	DEFAULT_TEXT_ATTRIBUTES,
	blockTypeToParentTagMap,
	isValidTextBlockType,
} from '$lib/types/AICopywriter/types';

const generateAttributes = (attributes: TextAttributes) => {
	return Object.entries(attributes)
		.map(([key, value]) => `${key}="${value}"`)
		.join(' ');
};

const generateListItemsHTML = (items: string[], attributes: string) => {
	const listItems = items.map((item) => `<li><p ${attributes}>${item}</p></li>`);
	return listItems.join('');
};

export const generatePostBlockHTML = (block: Block) => {
	if (!isValidTextBlockType(block.type)) {
		return null;
	}

	const parentTag = blockTypeToParentTagMap[block.type];
	const attributes = generateAttributes(DEFAULT_TEXT_ATTRIBUTES);

	switch (block.type) {
		case 'codeBlock': {
			return `<${parentTag} ${attributes}><code>${block.content}</code></${parentTag}>`;
		}
		case 'blockquote': {
			// Check if the content already contains HTML (like nested code blocks)
			const parser = new DOMParser();
			const innerHTMLContent = parser.parseFromString(block.content, 'text/html');

			if (innerHTMLContent.body.querySelector('pre')) {
				return `<${parentTag}>${block.content}</${parentTag}>`;
			}

			// Otherwise wrap in a paragraph
			return `<${parentTag}><p ${attributes}>${block.content}</p></${parentTag}>`;
		}
		case 'orderedList':
		case 'unorderedList': {
			const listItemsHTML = generateListItemsHTML(block.content, attributes);
			return `<${parentTag}>${listItemsHTML}</${parentTag}>`;
		}
		// Handles titles, subtitles, and paragraphs
		default: {
			return `<${parentTag} ${attributes}>${block.content}</${parentTag}>`;
		}
	}
};
